import { ProgressIndicator, Headline as UnifiedHeadline } from '@oneaudi/unified-web-components';
import { Ref, forwardRef } from 'react';
import ConsumptionFootnote from '~/app/compositions/content/calculation-info/components/consumption-footnote';
import { HeadlineStyle } from '~/app/pages/configurator/components/configurator-option/components/options-content/components/headline/styles/headline-style';
import { useConfigurator } from '~/graphql/hooks/use-configurator';
import { DATA_TEST_ID } from '~/test/data-test-id';

interface HeadlineProps {
	hideConsumptionEmissionEngineName: boolean;
}

export const Headline = forwardRef<HTMLDivElement, HeadlineProps>(
	({ hideConsumptionEmissionEngineName }: HeadlineProps, ref: Ref<HTMLDivElement>) => {
		const { catalog, loadingFlags } = useConfigurator();
		const carline = catalog.carInfo?.carline ?? 'Carline';
		const model = catalog.carInfo?.model ?? 'Model';
		return (
			<HeadlineStyle
				data-testid={DATA_TEST_ID.SELECTION_MODEL_TITLE}
				ref={ref}
				id={'option-headline'}
				className="headline option-headline">
				{loadingFlags.checkingConflicts && (
					<ProgressIndicator variant={'bar'} type={'infinite'} className="loader-indicator" />
				)}

				<UnifiedHeadline tag="h1" variant={{ type: 'headline', order: '3', weight: 'bold' }}>
					{carline}
				</UnifiedHeadline>
				<UnifiedHeadline tag="h2" variant={{ type: 'headline', order: '4', weight: 'normal' }}>
					{model}
					{!hideConsumptionEmissionEngineName && <ConsumptionFootnote />}
				</UnifiedHeadline>
			</HeadlineStyle>
		);
	},
);

Headline.displayName = 'Headline';
